import React, { useState } from 'react';
import { TriviaQuestion } from '../types';

interface QuestionCardProps {
  question: TriviaQuestion;
  onAnswer: (selectedIndex: number) => void;
}

const QuestionCard: React.FC<QuestionCardProps> = ({ question, onAnswer }) => {
  const [selected, setSelected] = useState<number | null>(null);

  const handleSelect = (index: number) => {
    if (selected !== null) return;
    setSelected(index);
    onAnswer(index);
  };

  return (
    <div className="w-full animate-fade-in">
      <div className="glass-card p-6 mb-6">
        <div className="text-5xl mb-4 text-center">{question.emoji}</div>
        <p className="text-white font-semibold text-lg leading-relaxed text-center">
          {question.text}
        </p>
      </div>

      <div className="flex flex-col gap-3">
        {question.options.map((option, index) => (
          <button
            key={index}
            onClick={() => handleSelect(index)}
            disabled={selected !== null}
            className={`w-full text-left px-5 py-4 rounded-2xl border transition-all duration-200 font-medium text-base min-h-[56px] ${
              selected === null
                ? 'bg-white/5 border-white/20 text-white hover:bg-white/10 hover:border-blue-400 active:scale-[0.98]'
                : selected === index
                ? 'bg-blue-600/30 border-blue-400 text-white'
                : 'bg-white/5 border-white/10 text-white/50 cursor-not-allowed'
            }`}
          >
            <span className="flex items-start gap-3">
              <span className="flex-shrink-0 w-6 h-6 rounded-full border border-current flex items-center justify-center text-sm">
                {String.fromCharCode(65 + index)}
              </span>
              <span>{option}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuestionCard;
